export default "__VITE_ASSET__BiBmAgMT__"